var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.manualParamList),function(manualParam){return _c('v-col',{key:manualParam.param_id,attrs:{"align-self":"center","align":"left"}},[_c('ManualParameter',{attrs:{"manualParameter":manualParam}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }